import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import localization from 'moment/locale/es';
import {
  makeSelectModalActive,
  makeSelectUrl,
  makeSelectRequestSended,
} from 'containers/CallRequestBox/selectors';
import {
  showModalAction,
  markAsSendedAction,
} from 'containers/CallRequestBox/actions';

import { activeMenuAction } from '../Menu/actions';
import { makeSelectIsActive } from '../Menu/selectors';

if (process.env.REACT_APP_ENVIRONMENT !== 'test') {
  moment.updateLocale('es', localization);
}

export class App extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div className="outer-container">
        {React.Children.toArray(this.props.children)}
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
  onActiveMenu: PropTypes.func.isRequired,
  onShowModal: PropTypes.func,
  markAsSended: PropTypes.func,
  isActive: PropTypes.bool,
  showModal: PropTypes.bool,
  isRequestSended: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  isActive: makeSelectIsActive(),
  showModal: makeSelectModalActive(),
  privacyPolicyUrl: makeSelectUrl(),
  isRequestSended: makeSelectRequestSended(),
});

function mapDispatchToProps(dispatch) {
  return {
    onActiveMenu: position => dispatch(activeMenuAction(position)),
    onShowModal: showModal => {
      dispatch(showModalAction(showModal));
    },
    markAsSended: () => dispatch(markAsSendedAction(true)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
